/**
 * GA4, landing pages only. Loaded after mount (never during prerender) so it
 * costs nothing on first paint. No-ops when VITE_GA4_ID is unset.
 *
 * Conversion events: any click on an element carrying data-conversion="…"
 * (phone links, form submits) is reported with that name.
 */

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const GA4_ID = import.meta.env.VITE_GA4_ID as string | undefined;

let loaded = false;

export const trackEvent = (name: string, params: Record<string, unknown> = {}) => {
  window.gtag?.('event', name, params);
};

export const initAnalytics = () => {
  if (!GA4_ID || loaded || typeof document === 'undefined') return;
  loaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: unknown[]) => {
    window.dataLayer?.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA4_ID, { send_page_view: true });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  // Delegated conversion tracking: one listener covers every
  // data-conversion element, including ones mounted later.
  document.addEventListener('click', (event) => {
    const target = (event.target as HTMLElement | null)?.closest?.('[data-conversion]');
    const name = target?.getAttribute('data-conversion');
    if (name) trackEvent(name);
  });
};

export const trackPageView = (path: string) => {
  if (!GA4_ID) return;
  window.gtag?.('event', 'page_view', { page_path: path });
};
